import { searchOrganisations } from '@infuse/api/iam/organisation';
import { searchTenantOrganisations } from '@infuse/api/iam/tenant';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericOrganisations } from './generic/useGenericOrganisations';

export const useOrganisations = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericOrganisations({
      apiFn: searchTenantOrganisations,
      queryKeys: ['organisations', 'tenant'],
      onlyEnableWithParentId: true,
      initialParentId: user?.tenantId
    });
  }

  return useGenericOrganisations({
    apiFn: searchOrganisations,
    queryKeys: ['organisations']
  });
};
